"use strict";

//Components
import Components from './components/components';
import Header from './components/header';
import Video from './components/video';

// Pages
import Services from './pages/services';

//Global
import Animation from './global/animation';

export default class App {
    constructor(){
        
        //Components
        const ComponentsComponent = document.querySelector('.component');
        const HeaderComponent = document.querySelector('.main-header');
        const VideoComponent = document.querySelector('.video');
        
        // Pages
        const ServicesComponent = document.querySelector('.services');

        //Global
        const AnimationComponent = document.querySelector('body');
        
        
        //Load component if necessary
        ComponentsComponent ? new Components() : null;
        HeaderComponent ? new Header() : null;
        VideoComponent ? new Video() : null;
        
        ServicesComponent ? new Services() : null;

        AnimationComponent ? new Animation() : null;

        console.log('start');

    }
}

new App();